<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="ProductOrder"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/ProductOrder/CoreProductOrderDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
            v-if="item.notion_id != null"
            color="primary"
            size="20"
            @click="onNotion(item)"
        >
          mdi-alpha-n-box-outline
        </v-icon>
      </template>
      <template v-slot:item.customer_order__name="{ item }">
        <span
            v-if="!!item.customer_order_uid && storeAggregate.rootData &&
            !!storeAggregate.rootData[item.customer_order_uid]">
          {{ storeAggregate.rootData[item.customer_order_uid].name }}
        </span>
      </template>
      <template v-slot:item.product__name="{ item }">
        <span v-if="!!item.product_uid && !! storeAggregate && !!storeAggregate.rootData &&
          !!storeAggregate.rootData[item.product_uid]">
          {{ storeAggregate.rootData[item.product_uid].name }}
        </span>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreProductOrderDetail from "@/components/CoreComponent/ProductOrder/CoreProductOrderDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "CoreProductOrderTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'CoreProductOrderTable'},
    dtoDetailQuery: {default: 'ProductOrderDetailQueryDTO'},
    detailStoreName: {default: 'ProductOrderDetail'},
    dtoValidateCommand: {type: [String], default: 'ProductOrderValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'ProductOrderListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ProductOrderActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreProductOrderDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 25},
      {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Notion', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true},
      {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Article number', value: 'article_number', sortable: true, filterable: true, divider: true},
      {text: 'Product', value: 'product__name', sortable: true, filterable: true, divider: true},
      // {text: 'Panasonic product', value: 'panasonic_product', sortable: true, align: 'end', divider: true, width: 100},
      {text: 'Customer order', value: 'customer_order__name', sortable: true, filterable: true, divider: true},
      {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>